import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Button,
  FormGroup,
  Spinner,
  CardFooter,
  Input,
} from "reactstrap";
import searchImg from "../assets/img/icons/search.svg";
import PickDateRange from "../components/shared/PickDateRange";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrders, updateOrder } from "store/actions/RequestActions";
import { orderPaymentRefund } from "store/actions/orderActions";
import moment from "moment";
import { toast } from "react-toastify";
import OrderRangeSlider from "components/Layout/OrderRangeSlider";
import PrintBill from "components/Orders/PrintBill";
import AssignDriver from "components/Modals/AssignDriver";
import { getRestaurantDrivers } from "store/actions/driverAction";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import Pagination from "components/shared/Pagination";
import DebouncedSearch from "components/shared/DebouncedSearch";
import { InstructionsModal } from "components/Modals/InstructionsModal";
import usePermissions from "hooks/usePermissions";
import { OrderItemsModal } from "components/Modals/OrderItemsModal";

const OrdersResturant = () => {
  const filters = [
    { name: "All", status: "" },
    { name: "New", status: "pending" },
    { name: "Processing", status: "processing" },
    { name: "Ready", status: "ready" },
    { name: "Served", status: "served" },
    { name: "Delivery", status: "delivery" },
    { name: "Completed", status: "completed" },
    { name: "Closed", status: "closed" },
    { name: "Refunded", status: "refunded" },
  ];
  const dispatch = useDispatch();
  const { restaurantOrders, orderLoader, restaurantOrdersRestData } =
    useSelector((state) => state.requests);
  const { restaurantsDetail } = useSelector((state) => state.restaurant);
  const { refundloading } = useSelector((state) => state.orders);
  const [openModal, setOpenModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState("");
  const { user } = useSelector((state) => state.auth);
  const adminColor =
    user?.adminColor || restaurantsDetail?.adminColor || "#cf327b";
  const [activeFilter, setActiveFilter] = useState(0);
  const [filterValue, setFilterValue] = useState(filters[0].status);
  const [value, setValue] = useState([0, 10000]);
  const [currentPage, setCurrentPage] = useState(0);
  const [modal, setModal] = useState(false);
  const [refundItem, setRefundItem] = useState({});
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const toggle = () => setModal(!modal);
  const [selectedNotes, setSelectedNotes] = useState([]);
  const [selectedOrderItems, setSelectedOrderItems] = useState([]);
  const [instructionsModalOpen, setInstructionsModalOpen] = useState(false);
  const [orderItemsModalOpen, setOrderItemsModalOpen] = useState(false);
  const [orderType, setOrderType] = useState("");
  const { edit: editAccess, get: getAccess } = usePermissions();
  const [isOrdersLoading, setIsOrdersLoading] = useState(false);
  const [isOrderRefundLoading, setIsOrderRefundLoading] = useState(false);
  const [disabledButtons, setDisabledButtons] = useState({});

  const [datestate, setDateState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const startDate = moment(datestate[0].startDate).startOf("day").unix();

  const endDate = moment(datestate[0].endDate).endOf("day").unix();

  const formatCreatedAt = (createdAt) => {
    return moment.unix(createdAt._seconds).format("DD MMM, YYYY, h:mm A");
  };

  const handleAssignDriver = (orderId) => {
    try {
      setSelectedOrderId(orderId);
      setOpenModal(true);
    } catch (err) {
      console.error(err.message);
    }
  };

  const assignToggle = () => {
    if (openModal && selectedOrderId) {
      setDisabledButtons((prev) => ({ ...prev, [selectedOrderId]: false }));
    }
    setOpenModal(!openModal);
  };

  const handleAssignmentComplete = (orderId) => {
    if (user?.restaurantID) {
      dispatch(getAllOrders(user?.restaurantID, filterValue, orderType));
    }
    setDisabledButtons((prev) => ({ ...prev, [orderId]: true }));
  };

  const handleSearch = (debouncedValue) => {
    setDebouncedSearch(debouncedValue);
  };

  const handleUpdateStatus = async (e, item, status) => {
    e.preventDefault();
    setDisabledButtons((prev) => ({ ...prev, [item.id]: true }));

    try {
      if (status === "ready") {
        await new Promise((resolve, reject) => {
          dispatch(updateOrder(item, status, resolve)).catch(reject);
        });

        if (item?.orderType === "delivery") {
          handleAssignDriver(item?.id, item);
        } else {
          setDisabledButtons((prev) => ({ ...prev, [item.id]: false }));
        }
      } else {
        await new Promise((resolve, reject) => {
          dispatch(updateOrder(item, status, resolve)).catch(reject);
        });
        setDisabledButtons((prev) => ({ ...prev, [item.id]: false }));
      }
    } catch (err) {
      console.error(err.message);
      setDisabledButtons((prev) => ({ ...prev, [item.id]: false }));
    }
  };

  const handleOrderTypeChange = (e) => {
    setOrderType(e.target.value);
  };
  const handlePaymentRefund = async (data) => {
    try {
      setIsOrderRefundLoading(true);
      if (
        data.paymentMethod === "Stripe" ||
        data.paymentMethod === "Paypal" ||
        data?.paymentMethod === "cash"
      ) {
        await dispatch(orderPaymentRefund(data));
        setIsOrderRefundLoading(false);
        toggle();
      } else {
        toast.warning("Invalid payment method");
        setIsOrderRefundLoading(false);
      }
    } catch (error) {
      console.error("Refund failed:", error);
      toast.error("Refund failed. Please try again.");
      setIsOrderRefundLoading(false);
    }
  };

  useEffect(() => {
    dispatch(getRestaurantDrivers(user?.restaurantID));
  }, [user?.restaurantID, dispatch]);

  useEffect(() => {
    setIsOrdersLoading(true);
    let unsubscribe;

    const loadOrders = async () => {
      unsubscribe = await dispatch(
        getAllOrders(
          debouncedSearch,
          user?.restaurantID,
          currentPage,
          startDate,
          endDate,
          value[0],
          value[1],
          orderType,
          filterValue,
          () => {
            setIsOrdersLoading(false);
          }
        )
      );
    };

    loadOrders();

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [
    currentPage,
    debouncedSearch,
    startDate,
    dispatch,
    endDate,
    value,
    user?.restaurantID,
    orderType,
    filterValue,
  ]);

  useEffect(() => {
    setCurrentPage(0);
  }, [debouncedSearch]);

  // Cleanup disabled buttons when filters change or component unmounts
  useEffect(() => {
    return () => {
      setDisabledButtons({});
    };
  }, [currentPage, debouncedSearch, filterValue, orderType]);
  return (
    <div className="orders pb-4 pt-0 pt-md-6">
      <Container className="mt-5 pt-2" fluid>
        <Card className="p-3 rounded-lg">
          <Row className="row my-2">
            <Col>
              <h2 className="mb-1">Orders</h2>
              <p className="text-muted">
                Manage your billing and payment details
              </p>
            </Col>
          </Row>

          <Row className="mx-2 d-lg-flex filters-row">
            {filters.map((filter, index) => {
              const isActive = activeFilter === index;
              const isDisabled = isOrdersLoading;

              return (
                <div
                  key={index}
                  className={`px-3 py-1 ${
                    isActive ? "filter-active" : "filter"
                  } ${isDisabled ? "filter-disabled" : ""}`}
                  style={{
                    borderBottom: isActive ? `2px solid ${adminColor}` : "none",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    opacity: isDisabled ? 0.5 : 1,
                  }}
                  onClick={() => {
                    if (isDisabled) return;
                    setCurrentPage(0);
                    setActiveFilter(index);
                    setFilterValue(filter.status);
                  }}
                >
                  <p
                    className="mb-0 text-capitalize"
                    style={{
                      color: isActive ? `${adminColor}` : "#64748b",
                    }}
                  >
                    {filter.name}
                  </p>
                </div>
              );
            })}
          </Row>

          <Row className="my-3 mx-2">
            <Col sm="12" md="6" lg="6">
              <FormGroup className="orders__form_group">
                <img src={searchImg} alt="search" />
                <DebouncedSearch
                  placeholder="Search by customer name, order name...."
                  onSearch={handleSearch}
                />
              </FormGroup>
            </Col>

            <Col sm="12" md="6" lg="6" className="my-2 my-lg-0">
              <OrderRangeSlider
                value={value}
                setValue={(newValue) => {
                  setTimeout(() => {
                    setValue(newValue);
                  }, 2000);
                }}
                setCurrentPage={setCurrentPage}
                adminColor={adminColor}
              />
            </Col>

            <Col sm="12" md="6" lg="6" className="mt-2">
              <PickDateRange
                setDateState={setDateState}
                datestate={datestate}
              />
            </Col>

            <Col sm="12" md="6" lg="6" className="mt-2">
              <Input
                type="select"
                value={orderType}
                onChange={handleOrderTypeChange}
              >
                <option value="">Select Order Type</option>
                <option value="dinein">Dine In</option>
                <option value="delivery">Delivery</option>
                <option value="takeaway">Take Away</option>
              </Input>
            </Col>
          </Row>

          <Row className="justify-content-around">
            <Col
              md={12}
              className="orders-table__col px-0"
              style={{
                "--scrollbar-color": adminColor,
              }}
            >
              {getAccess ? (
                <>
                  <Table
                    className="align-items-center table-flush mt-3 orders-table"
                    responsive
                  >
                    <thead className="thead-light">
                      <tr>
                        <th scope="col" className="text-center">
                          Name
                        </th>

                        <th scope="col" className="text-center">
                          Table no.
                        </th>

                        <th
                          scope="col"
                          style={{
                            width: "150px",
                          }}
                        >
                          Order
                        </th>

                        <th scope="col" className="text-center">
                          Instructions
                        </th>

                        <th scope="col" className="text-center">
                          CreatedAt
                        </th>
                        <th scope="col" className="text-center">
                          Type
                        </th>
                        <th scope="col" className="text-center">
                          Status
                        </th>

                        <th scope="col" className="text-center">
                          Payment
                        </th>

                        <th scope="col" className="text-center">
                          Amount
                        </th>
                        {editAccess && (
                          <th scope="col" className="text-center">
                            Actions
                          </th>
                        )}
                      </tr>
                    </thead>

                    <tbody>
                      {orderLoader || isOrdersLoading ? (
                        <tr>
                          <td colSpan="100%" className="text-center py-5">
                            <Spinner size="lg" color="primary" />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {restaurantOrders?.length > 0 ? (
                            <>
                              {restaurantOrders?.map((item, index) => (
                                <tr key={index}>
                                  <td className="text-center">
                                    {item?.customerName}
                                  </td>

                                  <td className="text-center">
                                    {item?.tableNumber}
                                  </td>

                                  <td>
                                    <Button
                                      size="sm"
                                      color="primary"
                                      onClick={() => {
                                        setSelectedOrderItems(item?.order);
                                        setOrderItemsModalOpen(true);
                                      }}
                                    >
                                      View
                                    </Button>
                                  </td>

                                  <td className="text-center">
                                    <>
                                      {item?.order?.some(
                                        (order) => order?.notes?.length > 1
                                      ) ? (
                                        <Button
                                          color="primary"
                                          size="sm"
                                          onClick={() => {
                                            const notesArray =
                                              item?.order?.filter(
                                                (order) =>
                                                  order?.notes?.length > 1
                                              );
                                            setSelectedNotes(notesArray);
                                            setInstructionsModalOpen(true);
                                          }}
                                        >
                                          View
                                        </Button>
                                      ) : (
                                        <span className="text-capitalize">
                                          ...
                                        </span>
                                      )}
                                    </>
                                  </td>

                                  <td className="text-center">
                                    {formatCreatedAt(item?.createdAt)}
                                  </td>

                                  <td className="text-center">
                                    <span
                                      style={{
                                        textTransform: "uppercase",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {item?.orderType}
                                    </span>
                                  </td>

                                  <td className="text-center">
                                    <span
                                      className={`status__${item?.status} text-capitalize`}
                                    >
                                      {item?.status}
                                    </span>
                                  </td>

                                  <td className="text-center">
                                    {item?.paymentMethod}
                                  </td>

                                  <td className="text-center">
                                    {item?.currency || "USD"}&nbsp;
                                    {item?.finalPrice
                                      ? item?.finalPrice
                                      : item?.totalAmount}
                                  </td>

                                  {editAccess || user?.type === "restaurant" ? (
                                    <td>
                                      <div
                                        className="d-flex justify-content-center align-items-center w-100 h-100"
                                        style={{ minHeight: "100%" }}
                                      >
                                        {item?.status === "ready" && (
                                          <>
                                            {item?.waiterID &&
                                            item?.waiterID !== "" ? (
                                              <Button
                                                disabled={true}
                                                size="sm"
                                                className="mx-1 w-100 orders-table__paid"
                                              >
                                                Move to Served
                                              </Button>
                                            ) : (
                                              <Button
                                                disabled={
                                                  (!item?.driverId &&
                                                    item?.orderType ===
                                                      "delivery") ||
                                                  (item?.orderType ===
                                                    "delivery" &&
                                                    item?.status === "ready") ||
                                                  disabledButtons[item.id]
                                                }
                                                size="sm"
                                                className="mx-1 w-100 orders-table__paid"
                                                onClick={(e) =>
                                                  handleUpdateStatus(
                                                    e,
                                                    item,
                                                    item?.orderType ===
                                                      "delivery"
                                                      ? "delivery"
                                                      : "completed"
                                                  )
                                                }
                                              >
                                                {item?.orderType === "delivery"
                                                  ? "Move to delivery"
                                                  : "Move to completed"}
                                              </Button>
                                            )}
                                          </>
                                        )}
                                        {item?.status === "served" && (
                                          <>
                                            <Button
                                              disabled={true}
                                              size="sm"
                                              className="mx-1 w-100 orders-table__paid"
                                            >
                                              Move to Completed
                                            </Button>
                                          </>
                                        )}

                                        {item.status === "delivered" && (
                                          <Button
                                            size="sm"
                                            disabled={disabledButtons[item.id]}
                                            className="mx-1 w-100 orders-table__paid"
                                            onClick={(e) =>
                                              handleUpdateStatus(
                                                e,
                                                item,
                                                "completed"
                                              )
                                            }
                                          >
                                            Move to completed
                                          </Button>
                                        )}

                                        {(item?.status === "pending" ||
                                          item?.status === "refunded") && (
                                          <Button
                                            size="sm"
                                            className="mx-1 w-100 orders-table__pending"
                                            disabled={
                                              item?.status === "refunded" ||
                                              disabledButtons[item.id]
                                            }
                                            onClick={(e) =>
                                              item?.status === "pending" &&
                                              handleUpdateStatus(
                                                e,
                                                item,
                                                "processing"
                                              )
                                            }
                                          >
                                            Move to Process
                                          </Button>
                                        )}

                                        {item?.status === "processing" && (
                                          <Button
                                            size="sm"
                                            className="mx-1 w-100 orders-table__process"
                                            disabled={
                                              item?.waiterID &&
                                              item?.waiterID !== ""
                                                ? true
                                                : disabledButtons[item.id]
                                            }
                                            onClick={(e) =>
                                              handleUpdateStatus(
                                                e,
                                                item,
                                                "ready"
                                              )
                                            }
                                          >
                                            Move to Ready
                                          </Button>
                                        )}

                                        {(item?.status === "completed" ||
                                          item?.status === "closed") && (
                                          <Button
                                            size="sm"
                                            className="mx-1 w-100 orders-table__process"
                                            disabled={
                                              item?.status === "closed" ||
                                              item?.status === "completed"
                                            }
                                          >
                                            Completed
                                          </Button>
                                        )}

                                        {item?.waiterID &&
                                        item?.waiterID !== "" ? (
                                          <Button
                                            size="sm"
                                            className="mx-1 w-100 orders-table__cancelled"
                                            disabled={true}
                                            onClick={() => {}}
                                          >
                                            {item?.status === "cancelled"
                                              ? "Cancelled"
                                              : "Cancel"}
                                          </Button>
                                        ) : (
                                          <Button
                                            size="sm"
                                            className="mx-1 w-100 orders-table__process"
                                            disabled={
                                              item?.paymentRecieved === false ||
                                              item?.status === "refunded" ||
                                              item?.status === "completed" ||
                                              item?.status === "closed"
                                            }
                                            onClick={() => {
                                              setRefundItem(item);
                                              toggle();
                                            }}
                                          >
                                            Refund
                                          </Button>
                                        )}

                                        {item?.orderType === "delivery" &&
                                          item?.status === "ready" && (
                                            <Button
                                              onClick={() =>
                                                handleAssignDriver(item?.id)
                                              }
                                              size="sm"
                                              className="mx-1 w-100 orders-table__process"
                                              disabled={
                                                item?.status === "refunded" ||
                                                (item?.orderType ===
                                                  "delivery" &&
                                                  item?.driverId) ||
                                                disabledButtons[item.id]
                                              }
                                            >
                                              Assign Driver
                                            </Button>
                                          )}

                                        <PrintBill
                                          order={item}
                                          restaurantCurrency={item?.currency}
                                        />
                                      </div>
                                    </td>
                                  ) : null}
                                </tr>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td colSpan="100%" className="text-center py-5">
                                No Order Added
                              </td>
                            </tr>
                          )}
                        </>
                      )}
                    </tbody>
                  </Table>
                </>
              ) : (
                <Row className="py-4 justify-content-center align-items-center">
                  You don't have the permission to access the page
                </Row>
              )}

              <CardFooter className="py-4">
                <Pagination
                  currentPage={currentPage}
                  totalPages={restaurantOrdersRestData?.nbPages}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </CardFooter>
            </Col>
          </Row>
        </Card>
      </Container>

      <ConfirmationModal
        title="Refund Order"
        text="Are you sure you want to refund the order?"
        isOpen={modal}
        toggle={toggle}
        isLoading={isOrderRefundLoading}
        onConfirmation={() => handlePaymentRefund(refundItem)}
      />

      <AssignDriver
        openModal={openModal}
        assignToggle={assignToggle}
        selectedOrderId={selectedOrderId}
        onAssignmentComplete={handleAssignmentComplete}
      />
      <InstructionsModal
        isOpen={instructionsModalOpen}
        toggle={() => setInstructionsModalOpen(false)}
        notes={selectedNotes}
      />
      <OrderItemsModal
        isOpen={orderItemsModalOpen}
        toggle={() => setOrderItemsModalOpen(false)}
        orderItems={selectedOrderItems}
      />
    </div>
  );
};

export default OrdersResturant;
